// import axios from '@/components/common/resouces/http.js'
import {get , post , ajax} from '@/components/common/resouces/http.js'
import global_ from '@/components/common/resouces/config'//引用模块进来
import router from '@/router'
import config from '../../components/common/resouces/config';

const state = {
  flag:1,//请求用户信息的开关
  isload:0,
  is_web_load:0,
  refresh_token:'',
  access_token:'',
  token_type:'',
  cancelTokenArr: [], // 取消请求token数组
  userInfo:[],
  size:10240,
  domain:'',
  publicdomain:'',
  currency_list:[],
  getlang:'',
  page_size:16,
  merchant_list:[],
  current_merchant:[],
  current_merchant_no:window.localStorage.getItem('current_merchant_no') || '',
  institutionInfo:{
    institution_name:'iConPay',
    institution_area_currency:[]
  },
  merchantCount:0,
  current_merchant_currency:'',
  frontMerchants:[],
  card_type:["VISA","MASTERCARD","AMEX","DINERSCLUB","DISCOVER","UNIONPAY","JCB"], 
  download_url:'',
  api_doc_url:'https://www.apihome.dev/egret/zh-cn/',
  version:'1.0.0',
  is_show_version:0,
  token_status:0,
  // 系统配置
  allow_currency:[],
  PLAT_SKIN:'',
  SUPPORT_PAY_METHOD:[],
  PARAMETER_VERSION:[],
  gateway_type:[],
  AREA_CURRENCY_MAP:[],
  statement_type:[],
  order_status_type:[],
  SUPPORT_PAY_MODE:[],
  plat_slogan:{},
  refund_status:[],
  
  plat_icon:'',
  plat_logo:'',
  plat_white_logo:'',
  plat_copyright:'',

}
const getter = {}
const mutations = {
    //退出
    logOut(state,res){  
        if(res.errcode == 0){
          window.localStorage.removeItem('access_token');
          window.localStorage.removeItem('refresh_token');
          window.localStorage.removeItem('token_type');
          window.localStorage.removeItem('current_merchant_no');          
          state.cancelTokenArr = []
          state.is_web_load = 0
          state.userInfo = []  
          state.merchant_list = [] 
          state.currency_list = [] 
          state.current_merchant = []   
          state.current_merchant_no = ''          
          state.flag = 1          
          router.replace('/login');
          setTimeout(()=>{
            window.location.reload();            
          },1000)

        }
    },
      
    clear(){
      window.localStorage.removeItem('access_token');
      window.localStorage.removeItem('refresh_token');
      window.localStorage.removeItem('token_type');
      window.localStorage.removeItem('current_merchant_no');          
      state.cancelTokenArr = []
      state.is_web_load = 0
      state.userInfo = []  
      state.merchant_list = [] 
      state.currency_list = [] 
      state.current_merchant = []   
      state.current_merchant_no = ''          
      state.flag = 1  
    },  

    pushToken(state, payload){
      state.cancelTokenArr.push(payload.cancelToken);
    },
    clearToken({cancelTokenArr}){
      // console.log(cancelTokenArr)
         cancelTokenArr.forEach(item => {                         
            item('路由跳转取消请求');
         });
         cancelTokenArr = [];
    },
    // 获取用户的信息
    SetUserInfo(state,res){
      state.flag = 0         
      state.userInfo = res.user_info
      state.merchant_list = res.merchant_list
      state.currency_list = res.currency_list
      state.merchantCount = Object.keys(res.merchant_list).length
      state.institutionInfo.institution_area_currency = res.support_area_currency

    },  
    //获取当前商户信息
    setMerchantInfo(state,res){          
      localStorage.setItem("current_merchant_no",res);    
      state.current_merchant_no = res;  
      if(Object.keys(state.merchant_list).indexOf(res) == -1){
        state.current_merchant_no = Object.keys(state.merchant_list)[0]
        localStorage.setItem("current_merchant_no",state.current_merchant_no);  
      }
      state.current_merchant =  state.merchant_list[res]   
      state.current_merchant_currency = state.merchant_list[res].merchant_currency  
    },
    //获取机构服务商信息
    set_config(state,res){
      state.email_test_open = res.email_test_open
      state.PLAT_SKIN = res.PLAT_SKIN
      state.allow_currency = res.allow_currency
      state.SUPPORT_PAY_METHOD = res.SUPPORT_PAY_METHOD
      state.PARAMETER_VERSION = res.PARAMETER_VERSION
      state.gateway_type = res.gateway_type
      state.AREA_CURRENCY_MAP = res.AREA_CURRENCY_MAP
      state.statement_type = res.statement_type
      state.order_status_type = res.order_status
      state.SUPPORT_PAY_MODE = res.SUPPORT_PAY_MODE
      state.plat_slogan = res.plat_slogan
      state.refund_status = res.refund_status
      state.refund_type = res.refund_type

       //所有LOGO图片,版权信息加入管理
       state.plat_icon = res.plat_icon //导航icon
       state.plat_logo = res.plat_logo //前后台登录页logo
       state.plat_white_logo = res.plat_white_logo //白底logo
       state.plat_copyright = res.plat_copyright //版权信息
 
       //直接在这里设置icon吧
       let favicon = document.createElement("link")
       favicon.rel = "icon"
       favicon.href = state.plat_icon;
       document.head.appendChild(favicon);              
     
    },

    setDomain(state,res){        
      state.domain = global_.gloabUrl+'merchant';
      state.publicdomain = global_.gloabUrl
      state.download_url = state.publicdomain          
    },
    setLang(){
       var l = localStorage.getItem("language");  
       if(l == 'zh-cn'){
          state.getlang = 'zh'
       }else{
          state.getlang = 'en'        
       }
    },

    changeFlag(state){
      state.flag = 1
      state.isload = 0
      state.is_web_load = 1
      // console.log(state.flag)
    },
    emptyInfo(state){
      window.localStorage.removeItem('access_token');
      window.localStorage.removeItem('refresh_token');
      window.localStorage.removeItem('token_type');
      window.localStorage.removeItem('current_merchant_no');          
      router.replace('/login');
      state.is_web_load = 0      
      state.userInfo = []  
      state.merchant_list = []  
      state.currency_list = []       
      state.current_merchant = []   
      state.current_merchant_no = ''        
      state.flag = 1
    },
    checkVersion_1(state,payload){
      state.is_show_version = payload
    }
}
const actions = {
  //退出
  logOut(context,payload){
    UIkit.modal.confirm("Are you sure?", function(){    
      let url = state.domain + '/UserAuth/logout'      
      post(url).then(res => {        
          if(res.data.errcode == 0 ){
              context.commit('logOut', res.data)            
          }          
      })
    })
  },
 
  //获取用户的信息
  getUserInfo(context,payload){
    context.commit('SetUserInfo', payload);

  },
  
  //获取当前商户信息
  getMerchantInfo(context,payload){
    context.commit('setMerchantInfo', payload);

  },
  //获取域名方法 
  getDomain(context,payload){
      context.commit('setDomain', payload);

  },

  cleanInfo(context,payload){
    context.commit('emptyInfo', payload);
  },

  get_Lang(context){
    context.commit('setLang');
  },
  setclearToken(context){
    context.commit('clearToken');

  },
  get_config(context,payload){
    context.commit('set_config',payload);
  },



}
export default {
  state,
  getter,
  mutations,
  actions
}







// WEBPACK FOOTER //
// ./src/store/modules/home.js